import { AfterViewInit, Component, effect, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import ptBR from 'src/translations/pt-BR.json';
import { Userpilot } from 'userpilot';
import { environment } from '@env';
import { SessionService } from '@services/session.service';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {

  hasCreditCard: any;
  title = 'app-tollmanagement';
  private readonly env = environment;

  constructor(
    private readonly translateService: TranslateService,
    private readonly sessionService: SessionService,
    private readonly authService: AuthService,
  ) {
    effect(() => {
      if (this.sessionService.sessionExpired()) {
        setTimeout(() => this.authService.logOut(), 5000);
      }
    });
  }

  ngOnInit() {
    this.addTranslate();
    this.initializeUserPilot();
  }

  ngAfterViewInit() {
    this.startEnvJavaScript();
    this.startMsClarityJS();
    this.startGoogleTagManagerJS();
    this.removerInfoLocalStorage();
  }

  private addTranslate(): void {
    this.translateService.setTranslation('pt-BR', ptBR);
    this.translateService.use('pt-BR');
  }

  private initializeUserPilot() {
    Userpilot.initialize(environment.userPilotId);
  }

  private startEnvJavaScript(): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text =
      'window.__env = window.__env || {};' +
      `window.__env.deploymentId = ${JSON.stringify(this.env.deploymentId)};`;
    document.body.appendChild(script);
  }

  private startMsClarityJS(): void {
    localStorage.setItem('msClarity', this.env.msClarity);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '/assets/scripts/ms-clarity.js';
    document.body.appendChild(script);
  }

  private startGoogleTagManagerJS(): void {
    localStorage.setItem('googleTagManagerId', this.env.googleTagManagerId);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '/assets/scripts/google-tag-manager.js';
    document.body.appendChild(script);
  }

  private removerInfoLocalStorage() {
    setTimeout(() => {
      localStorage.removeItem('msClarity');
      localStorage.removeItem('googleTagManagerId');
    }, 500);
  }
}
